"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResultUrlService = void 0;
const app_1 = require("app");
const constants_1 = require("../constants");
const DEFAULT_PAGE_SIZE = 10;
const FIRST_PAGE = 0;
class SearchResultUrlService {
    syncToUrl(params) {
        const urlObj = app_1.UrlService.GetObjectFromUrlString();
        const activeFilterKeys = new Set();
        // Query
        const queryValue = typeof params.query === 'string' ? params.query : '*';
        this.setParam(urlObj, 'query', queryValue);
        // Tab
        this.setParam(urlObj, params.tabUrlKey, params.tabKey);
        // Filters
        this.applyMenuParams(params.menu, urlObj, activeFilterKeys, params.tabFilterPrefix);
        this.applyRefinementListParams(params.refinementList, urlObj, activeFilterKeys, params.tabFilterPrefix);
        this.applyHierarchicalMenuParams(params.hierarchicalMenu, urlObj, activeFilterKeys, params.tabFilterPrefix);
        this.removeStaleFilterKeys(urlObj, params.tabFilterPrefix, activeFilterKeys);
        // Pagination
        this.applyPaginationParams(urlObj, params.page, params.hitsPerPage);
        const newUrlStr = app_1.UrlService.GetStringFromUrlObj(urlObj);
        const currentUrlStr = window.location.search;
        if (newUrlStr !== currentUrlStr) {
            window.history.pushState(urlObj, null, newUrlStr || document.location.pathname);
        }
    }
    setParam(urlObj, key, value) {
        urlObj[key] = value;
    }
    applyMenuParams(menu, urlObj, activeKeys, prefix) {
        for (const [key, value] of Object.entries(menu)) {
            if (constants_1.EXCEPTIONAL_REFINEMENT_KEYS.has(key))
                continue;
            const urlKey = `${prefix}_${key}`;
            activeKeys.add(urlKey);
            urlObj[urlKey] = String(value);
        }
    }
    applyRefinementListParams(refinementList, urlObj, activeKeys, prefix) {
        for (const [key, values] of Object.entries(refinementList)) {
            if (constants_1.EXCEPTIONAL_REFINEMENT_KEYS.has(key))
                continue;
            const urlKey = `${prefix}_${key}`;
            activeKeys.add(urlKey);
            urlObj[urlKey] = app_1.UtilService.toQuotedCsv(values);
        }
    }
    applyHierarchicalMenuParams(hierarchicalMenu, urlObj, activeKeys, prefix) {
        for (const [, values] of Object.entries(hierarchicalMenu)) {
            const urlKey = `${prefix}_${constants_1.HIERARCHIES_KEY}`;
            activeKeys.add(urlKey);
            urlObj[urlKey] = app_1.UtilService.toQuotedCsv(values);
        }
    }
    removeStaleFilterKeys(urlObj, prefix, activeKeys) {
        for (const key of Object.keys(urlObj)) {
            if (key.startsWith(`${prefix}_`) && !activeKeys.has(key)) {
                delete urlObj[key];
            }
        }
    }
    applyPaginationParams(urlObj, page, pageSize) {
        const currentPage = typeof page === 'number' ? page : FIRST_PAGE;
        const currentPageSize = typeof pageSize === 'number' ? pageSize : DEFAULT_PAGE_SIZE;
        if (currentPageSize !== DEFAULT_PAGE_SIZE) {
            urlObj['pageSize'] = String(currentPageSize);
        }
        else {
            delete urlObj['pageSize'];
        }
        if (currentPage > FIRST_PAGE) {
            urlObj['page'] = String(currentPage);
        }
        else {
            delete urlObj['page'];
        }
    }
}
exports.searchResultUrlService = new SearchResultUrlService();
